var layout_default = {
  "layoutWrapper": "OvgnE",
  "layout": "sJllg",
  "designOnLayout": "so7PZ",
  "designOnCell": "FfOa5",
  "cell": "_7GM66",
  "mobile": "BirDp"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
